{
    "CallControlMcError": "There was an error whilst trying to connect to ",
    "CallControlActionError": "There was an error when trying to perform the action ",
    "CallControlCompleteTransferError": "There was an error in completing transfer ",
    "CallControlPickupCallError": "There was an error in picking up call ",
    "CallControlChangingDndError": "There was an error in changing DND status for ",
    "CallControlConnectionUpdate": "There was an error in connection update ",
    "CallControlDeletePhantom": "There was an error in when trying to delete phantom call.",
    "CallControlAcdStatusUpdate": "There was an error in ACD status update ",
    "CallControlSetAccountCode": "There was an error when trying to set the account code",
    "CallControlMonitoringActionError": "There was an error in monitoring action ",
    "CallControlUserInfoMissing": "User Info is missing. This could indicate you are no longer authenticated. Please try signing out and in again.",
    "CallControlTelPartDevError": "Telephony server, Partition, Agent or Device were not available.",
    "NAME": "CallControlErrors"
}
